import React, { useContext } from "react";
import styled, { keyframes } from "styled-components";
// import { Image } from "@pancakeswap/uikit";
import Image from "next/image";
import Flex from "../../../components/Box/Flex";
import { NextLinkFromReactRouter } from "../../../components/NextLink";
import { LogoIcon, LogoWithTextIcon } from "../../../components/Svg";
import { MenuContext } from "../context";

interface Props {
  href: string;
}

const blink = keyframes`
  0%,  100% { transform: scaleY(1); }
  50% { transform:  scaleY(0.1); }
`;

const StyledLink = styled("a")`
  display: flex;
  .mobile-icon {
    width: 32px;
    ${({ theme }) => theme.mediaQueries.lg} {
      display: none;
    }
  }
  .logo-img {
    width: 215px;
    height: 48px;
  }
  .desktop-icon {
    width: 160px;
    display: none;
    ${({ theme }) => theme.mediaQueries.lg} {
      display: block;
    }
  }
  .eye {
    animation-delay: 20ms;
  }
  &:hover {
    .eye {
      transform-origin: center 60%;
      animation-name: ${blink};
      animation-duration: 350ms;
      animation-iteration-count: 1;
    }
  }
`;

const Logo: React.FC<React.PropsWithChildren<Props>> = ({ href }) => {
  const { linkComponent } = useContext(MenuContext);
  const isAbsoluteUrl = href.startsWith("http");
  const innerLogo = (
    <>
      <Image className="mobile-icon" src="/images/logo-small.svg" height={40} width={40} alt="" />
      <Image className="desktop-icon logo-img" src="/images/logo-text.svg" height={48} width={215} alt="" />
    </>
  );

  return (
    <Flex alignItems="center">
      {/* {isAbsoluteUrl ? (
        <StyledLink as="a" href={href} aria-label="Pancake home page">
          {innerLogo}
        </StyledLink>
      ) : (
        <StyledLink href={href} as={linkComponent} aria-label="Pancake home page">
          {innerLogo}
        </StyledLink>
      )} */}
      <StyledLink as={NextLinkFromReactRouter} to="/">
        {innerLogo}
      </StyledLink>
    </Flex>
  );
};

export default React.memo(Logo);
